import { Stack, Typography } from "@mui/material";
import React, { useMemo } from "react";
import { useTheme } from "styled-components";
import MiddleCard from "../../components/cards/MiddleCard";
import SubmitButton from "../../components/SubmitButton";
import { useAuth } from "../../contexts/AuthContext";
import { useError } from "../../contexts/ErrorContext";
import { useLogin } from "../../contexts/LoginContext";
import { useApp } from "../../contexts/AppContext";
const EmailConfirmation: React.FC = () => {
  const { username } = useLogin();
  const { showError } = useError();
  const { resetPassword } = useAuth();

  const { translate } = useApp();
    const authTranslations = useMemo(() => translate("auth"), [translate]);

  const resendEmail = async () => {
    try {
      await resetPassword(username);
    } catch (error) {
      showError(authTranslations.errors.verification_not_sent);
    }
  };

  const theme = useTheme();

  return (
    <MiddleCard>
      <Stack spacing={2}>
        <Typography variant="h6" gutterBottom>
          {authTranslations.email_verification.title}
        </Typography>
        <Typography variant="body1" color="textSecondary" mb={3}>
          {authTranslations.email_verification.subtitle}
        </Typography>
        <SubmitButton
          sx={{
            alignSelf: "flex-end",
            width: "auto",
            px: theme.spacing(2),
            border: "none",
          }}
          onClick={resendEmail}
          color={"greyButton"}
        >
          {authTranslations.email_verification.resend}
        </SubmitButton>
      </Stack>
    </MiddleCard>
  );
};
export default EmailConfirmation;
